import { useEffect, useState } from "react";

/** true mientras la consulta de medios se cumpla (p. ej. "(max-width: 767px)"); se actualiza al girar o redimensionar. */
export function useMedia(query) {
  const leer = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [ok, setOk] = useState(leer);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const m = window.matchMedia(query);
    const fn = () => setOk(m.matches);
    fn();
    m.addEventListener ? m.addEventListener("change", fn) : m.addListener(fn);
    return () => (m.removeEventListener ? m.removeEventListener("change", fn) : m.removeListener(fn));
  }, [query]);
  return ok;
}

export const useEsMovil = () => useMedia("(max-width: 767px)");
